import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SidebarButton } from '@/components/Layout/SidebarButton';
import AccountList from '@/components/AccountList';
import { AnchoredModal } from '@/components/Overlay';
import { useAccounts } from '@/hooks/useAccounts';

export const AccountSwitcher: React.FC = () => {
  const navigate = useNavigate();
  const { accountId } = useParams<{ accountId?: string }>();
  const { accounts, loading } = useAccounts();

  const anchorRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const current = accounts.find(a => String(a.id) === accountId) ?? accounts[0];

  const handleToggle = () => setOpen(v => !v);
  const handleClose = () => setOpen(false);

  const handleSelect = (acc: { id: string; name: string }) => {
    if (accountId !== acc.id) {
      navigate(`/account/${acc.id}`);
    }
    handleClose();
  };

  return (
    <>
      <div
        ref={anchorRef}
        role="button"
        tabIndex={0}
        onClick={handleToggle}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && handleToggle()}
        className="outline-none border-none w-[50%]"
      >
        <SidebarButton header="Company" title={current?.name ?? 'Aimes'} />
      </div>

      <AnchoredModal
        open={open && !loading}
        anchorRef={anchorRef as React.RefObject<HTMLElement>}
        onClose={handleClose}
        placement="bottom-start"
        offset={16}
        panelClassName="rounded-2xl"
      >
        <AccountList
          accounts={accounts}
          selectedAccountId={accountId ?? null}
          onSelect={handleSelect}
        />
      </AnchoredModal>
    </>
  );
};
